import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import ComplicationSelector from "@ls/grouping-complication-selector";
import { setDefinition as setPivotDefinition } from "state/pivots/actions";
import PivotDefinition from "state/pivots/PivotDefinition";
import { selectDefinitions } from "state/pivots/selectors";
import SelectionState from "state/selections/SelectionState";
import Complication from "./PivotsSelectorComplication";

const PivotsSelector = () => {
  const dispatch = useDispatch();
  const definitions = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  );
  const setDefinition = useCallback(
    (definitions, idx) => dispatch(setPivotDefinition(definitions, idx)),
    [dispatch]
  );

  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      setDefinition={setDefinition}
      getDefaultDefinition={PivotDefinition.getDefault}
      ComplicationComponent={Complication}
      btnTitle={"Pivots"}
      addMoreText={"Pivot"}
    />
  );
};

export default PivotsSelector;
